import { Routes, Route, Navigate } from "react-router-dom";
import { LoginForm, ResetPasswordForm, ChangePasswordForm } from "./components";

export default function UnauthenticatedContent() {
  return (
    <Routes>
      <Route path="/login" element={<LoginForm />} />
      <Route path="/reset-password" element={<ResetPasswordForm />} />
      <Route path="/change-password" element={<ChangePasswordForm />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
